import { FC, useState } from 'react';
import { Page, PageTitleWithBack, TabsBar } from '../../../components';
import { StaticFileManagement } from './static-file-management';
import { Box, Tab, Tabs } from '@mui/material';
import { DynamicFileManagement } from './dynamic-file-management';

interface IFileManagement {}

export const FileManagement: FC<IFileManagement> = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  return (
    <Page title={'File Management'}>
      <PageTitleWithBack
        showDivider={false}
        backText="Back to Documentation home"
        backUrl="/documentation"
        title="File Management"
      />
      <Box mt={-1}>
        <TabsBar>
          <Tabs
            value={selectedTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(_, value) => {
              setSelectedTab(value);
            }}
          >
            <Tab id="dynamic" aria-controls="dynamic" label="Dynamic file management" />
            <Tab id="static" aria-controls="static" label="Static file management" />
          </Tabs>
        </TabsBar>
      </Box>
      {selectedTab === 0 && <DynamicFileManagement />}
      {selectedTab === 1 && <StaticFileManagement />}
    </Page>
  );
};
